export class InputModal {
    constructor(title, initialValue, onConfirm, placeholder = '') {
        this.title = title;
        this.value = initialValue || '';
        this.onConfirm = onConfirm;
        this.placeholder = placeholder;
    }

    render() {
        this.cleanup();

        // 1. Overlay (Backdrop)
        this.overlay = document.createElement('div');
        this.overlay.className = "fixed inset-0 bg-black/50 z-[9990] flex items-center justify-center p-4 backdrop-blur-sm transition-opacity duration-300 opacity-0";

        // 2. Modal Content
        this.modal = document.createElement('div');
        this.modal.className = "bg-white dark:bg-zinc-900 rounded-2xl shadow-2xl max-w-sm w-full p-6 transform scale-95 transition-all duration-300 opacity-0 border border-zinc-100 dark:border-zinc-800";

        this.modal.innerHTML = `
      <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2">${this.title}</h3>
      <p class="text-sm text-zinc-500 mb-4">내용을 입력해주세요.</p>
      
      <div class="mb-6">
        <input type="text" id="modal-input-field" 
          class="w-full px-4 py-3 rounded-xl bg-gray-50 dark:bg-zinc-800 border border-gray-200 dark:border-zinc-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-violet-500 transition-all text-sm font-medium" 
          placeholder="${this.placeholder}" 
          value="${this.value}" 
        />
      </div>

      <div class="flex items-center gap-3">
        <button id="btn-cancel" class="flex-1 py-3 bg-gray-100 hover:bg-gray-200 dark:bg-zinc-800 dark:hover:bg-zinc-700 text-gray-700 dark:text-zinc-300 rounded-xl font-bold text-sm transition-colors">
          취소
        </button>
        <button id="btn-confirm" class="flex-1 py-3 bg-violet-600 hover:bg-violet-700 text-white rounded-xl font-bold text-sm transition-colors shadow-lg shadow-violet-500/30">
          확인
        </button>
      </div>
    `;

        this.overlay.appendChild(this.modal);
        document.body.appendChild(this.overlay);

        // Event Listeners
        this.overlay.addEventListener('click', (e) => {
            if (e.target === this.overlay) this.close();
        });

        const input = this.modal.querySelector('#modal-input-field');
        const btnCancel = this.modal.querySelector('#btn-cancel');
        const btnConfirm = this.modal.querySelector('#btn-confirm');

        btnCancel.onclick = () => this.close();
        btnConfirm.onclick = () => {
            this.onConfirm(input.value);
            this.close();
        };

        // Auto Focus
        setTimeout(() => {
            input.focus();
            // Move cursor to end
            input.setSelectionRange(input.value.length, input.value.length);
        }, 50);

        // Enter Key
        input.onkeyup = (e) => {
            if (e.key === 'Enter') btnConfirm.click();
        };

        // Animation In
        requestAnimationFrame(() => {
            this.overlay.classList.remove('opacity-0');
            this.modal.classList.remove('opacity-0', 'scale-95');
            this.modal.classList.add('scale-100');
        });
    }

    close() {
        if (this.overlay) {
            this.overlay.classList.add('opacity-0');
            this.modal.classList.add('opacity-0', 'scale-95');
            setTimeout(() => {
                this.cleanup();
            }, 300);
        }
    }

    cleanup() {
        if (this.overlay) this.overlay.remove();
    }
}
